module.exports = __webpack_public_path__ + "static/media/industries-mortar-s.52321d7a.jpg";